<template>
    <div class="dropdown-content dropdown-content-padded">
        <button class="btn btn-s" @click="update" @mouseenter="$emit('enter')" @mouseleave="$emit('leave')">Add Filter</button>
    </div>
</template>

<script>
    export default {
        methods: {
            update() {
                this.$emit('update');
            },
        },
    };
</script>
